<template>
  <div>
    <v-row>
      <!-- Exercise column -->
      <v-col cols="12" v-if="content">
        <exercise-logic
          :exCollection="$route.meta.model"
          :saveState="saveState"
          @ready="onReady"
          @error="onError"
          @saved="onSaved"
          @savedNext="onSavedNext"
          @loadedEx="onLoadedEx"
          :doc="doc"
          :shared="true"
          :pid="false"
        >
          <template slot-scope="{ saveExercise }">
            <div class="relative">
              <v-row>
                <v-col cols="4" class="mb-4">
                  <h2
                    class="headline"
                    v-text="content.exercise_attributes.step1.title"
                  ></h2>
                </v-col>

                <v-col cols="8" offset="4" class="">
                  <p
                    v-for="(item, index) in content.exercise_attributes.step1
                      .description"
                    :key="index"
                    v-text="item"
                  />
                </v-col>
              </v-row>

              <v-row v-if="doc">
                <v-col cols="12">
                  <v-card
                    height="100%"
                    :color="content.exercise_benefits.color"
                  >
                    <v-card-text>
                      <attributes-area
                        v-model="doc.attributes"
                        name="attributes"
                        :title="content.exercise_attributes.col1"
                        subtitle=""
                        :content="content"
                        @handleEnd="handleEnd"
                      ></attributes-area>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </div>

            <bottom-navigation
              :save="true"
              :next="false"
              :prev="false"
              :gridView="false"
              :gridToggle="false"
              @save="saveExercise(true)"
            >
            </bottom-navigation>
          </template>
        </exercise-logic>
      </v-col>
    </v-row>

    <v-dialog v-if="content" v-model="dialog" max-width="800">
      <v-card>
        <v-card-title class="headline">{{
          content.exercise_benefits.saved.title
        }}</v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn class="amber black--text" text @click="dialog = false">
            Close
          </v-btn>

          <v-btn color="amber accent-1 black--text" text to="/users/dashboard">
            Back to Dashboard
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { BottomNavigation } from "@/components/core";
import { ExerciseLogic } from "@/components/exercises";

import { AttributesArea } from "@/views/user/exercises/attributes";

export default {
  name: "UserAttributes",

  async created() {
    // GET request using fetch with async/await
    const response = await fetch(`/content/${this.$route.params.id}.json`);
    const data = await response.json();
    this.content = data;
  },

  data() {
    return {
      content: null,
      e1: 1,
      exercises: null,
      refs: null,
      dialog: false,
      allItems: null,
      listName: "",
      saveState: false,
      autoSave: true,
      results: {
        items: [],
      },
      doc: {
        attributes: [],
      },
      list: [],
      listLength: 1,
      debug: false,
    };
  },
  components: {
    BottomNavigation,
    ExerciseLogic,
    AttributesArea,
  },
  watch: {
    e1(val) {
      if (val === 3) {
        this.createList();
      }
    },
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
    isAdmin() {
      return this.currentUser.uid === "4jd41CisaJZmDYMwCGMRhFclhXY2";
    },
  },
  mounted() {},

  methods: {
    nextStep() {
      this.e1++;
    },
    prevStep() {
      this.e1--;
    },
    onReady() {},
    onError() {
      console.log("error");
    },
    onSaved() {
      console.log("saved ex");
      this.dialog = true;
    },
    onLoadedEx(items) {
      if (items) {
        this.mergeArrays(items.doc);
      }
    },
    onSavedNext() {
      this.nextStep();
    },
    getResults(doc) {
      this.pushToArray(doc.selectedList, "items", "grey lighten-3");
    },
    pushToArray(arr, model, color) {
      if (arr || arr.length > 0 || arr != undefined) {
        arr.forEach((y) => {
          this.results[model].push({
            title: y.title,
            description: y.description,
            color: color,
          });
        });
      }
    },
    clone(obj) {
      Object.assign({}, obj);
    },
    mergeArrays(arr) {
      console.log("arr", arr);
      this.$set(this.doc, "attributes", arr.attributes);
    },
    createList() {
      let items = [];
      Object.values(this.doc.matrix).forEach((value) => {
        value.forEach((x) => {
          x.color = "blue lighten-4";
          items.push(x);
        });
      });
      let itemsFromList = [];
      Object.values(this.doc.list).forEach((value) => {
        value.forEach((x) => {
          itemsFromList.push(x);
        });
      });
      let all = [];
      items.forEach((x) => {
        if (!itemsFromList.some((y) => y.title == x.title)) {
          all.push(x);
        }
      });
      this.doc.allItems = all;
    },
    closeDialog() {
      this.dialog = false;
    },
    handleEnd() {
      this.doAutoSave();
    },
    doAutoSave() {
      if (this.autoSave) {
        this.saveState = true;
      }
    },
  },
};
</script>

<style lang="scss"></style>
